import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class EventScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            saved: false,
            isDraft : false, 
            instituteOptions: [],
            productOptions: [],  
            programOptions: [], 
            typeOptions: [],
            regionOptions: [],
            projectOptions: [],
            statusOptions: [
            { value: 'planned', label: 'Запланировано' },
            { value: 'completed', label: 'Завершено' },
            { value: 'canceled', label: 'Отменено' },
            ],
            role: sessionStorage.getItem("role"),
            currentEvent: {id: null, 
                            name: "", 
                            projectid: null,
                            project: "",
                            programid: null,
                            program: "",
                            productid: null,
                            product: "",
                            regionid: "",
                            region: "",
                            institutionid: null,
                            institution: "",
                            start: null,
                            end: null,
                            occupation: 0,
                            typeid: null,
                            type: "",
                            status: "planned",
                            statusLabel: "Запланировано"},
            validation: {
                isValid: true,
                start: true,
                end: true,
                project: true,
                program: true,
                product: true,
                institution: true,
                type: true
            }                
        };

        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.handleChangeOccupation = this.handleChangeOccupation.bind(this);         
        this.handleChangeInstitution = this.handleChangeInstitution.bind(this); 
        this.handleChangeProduct = this.handleChangeProduct.bind(this); 
        this.handleChangeProgram = this.handleChangeProgram.bind(this); 
        this.handleChangeType = this.handleChangeType.bind(this); 
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.handleChangeProject = this.handleChangeProject.bind(this);

        this.save = this.save.bind(this);   
        this.delete = this.delete.bind(this);                      
    }

    timerId = null;

    async componentDidMount() {

        if (this.props.args.event && this.props.args.event.length > 0) {
            BaseApi.get("/event", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {id: this.props.args.event}, withCredentials: true})
            .then(res => {
                this.setState({currentEvent: res.data})
            }) 
            .catch()
        } else {
            this.validate()
            this.setState({isDraft: true})
        }

        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({regionOptions: regionOptions})
        })    
        .catch()

        BaseApi.get("/project/projects", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            const projectOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({projectOptions: projectOptions})
        })    
        .catch()

        BaseApi.get("/event/types", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            const typeOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({typeOptions: typeOptions})
        })    
        .catch()
    }

    async componentDidUpdate(prevProps, prevState) {
        
        if (this.state.currentEvent != prevState.currentEvent) {
            this.validate()
        } 

        if (this.state.currentEvent.projectid != prevState.currentEvent.projectid) {
            this.getProgramOptions()
        }
        if (this.state.currentEvent.regionid != prevState.currentEvent.regionid) {
            this.getInstitutionOptions()
        }
        if (this.state.currentEvent.programid != prevState.currentEvent.programid) {
            this.getProductOption()
        }    
    }

    async componentWillUnmount() {
        this.timerId = null
    }

    getInstitutionOptions() {
        if (this.state.currentEvent.regionid.length > 0) {
            BaseApi.get("/institutions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true, regionid: this.state.currentEvent.regionid}, withCredentials: true})
            .then(res => {
                const instituteOptions = res.data.map(({id, name}) => ({value: id, label: name}))
                this.setState({instituteOptions: instituteOptions})
            })    
            .catch()
        } else {
            this.setState({institutionOptiosn: []})
        } 
    }

    getProgramOptions() {
        console.log("CAV getProgramOptions")
        console.log(this.state.currentEvent)
        if (this.state.currentEvent.projectid) {
            BaseApi.get("/project/project/programs", {headers: {
                'Content-Type': 'application/json', 
                'SESSIONID': sessionStorage.getItem("session")},
                params: {id: this.state.currentEvent.projectid},
                 withCredentials: true})
            .then(res => {
                console.log(res)
                const programOptions = res.data.map(({programid, name}) => ({value: programid, label: name}))
                this.setState({programOptions: programOptions})
            })    
            .catch()
        } else {
            this.setState({programOptions: []})
        }   
    }

    getProductOption() {

        if (this.state.currentEvent.programid) {

            BaseApi.get("/products", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {programid: this.state.currentEvent.programid}, withCredentials: true})
            .then(res => {
                console.log("Product options")
                console.log(res.data)
                const productOptions = res.data.map(({productid, name}) => ({value: productid, label: name}))
                this.setState({productOptions: productOptions})
            })    
            .catch()
        } else {
            this.setState({productOptions:[]})
        }
    }

    getOptions() {
        console.log("CAV get options")
        this.getProgramOptions()
        this.getProductOption()
        this.getInstitutionOptions()
    }

    save(event) {
        BaseApi.post('/event', this.state.currentEvent, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentEvent = this.state.currentEvent
            currentEvent.id = res.data.id
            this.setState({currentEvent: currentEvent, isDraft: false, saved: true})
            this.props.args.event = res.data.id

            if (this.timerId) {
                clearTimeout(this.timerId);
            }

            this.timerId = setTimeout(() => {
                this.setState({ saved: false });
                this.timerId = null;
            }, 1000);

        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    delete() {
        BaseApi.delete('/event', {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, 
            params: {id: this.state.currentEvent.id},
            withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
    }

    validate() {
        const currentEvent = this.state.currentEvent
        const start = this.validateDate(currentEvent.start)
        const end = this.validateDate(currentEvent.end)
        const project = currentEvent.projectid !== null && currentEvent.projectid.length > 0
        const product = currentEvent.product.length > 0
        const program = currentEvent.program.length > 0
        const institution = currentEvent.institutionid && currentEvent.institutionid.length > 0
        const type = currentEvent.type.length > 0   
        
        this.setState({
            validation: {
                isValid: start && end && project && product && program && institution && type, 
                start: start,
                end: end,
                project: project,
                product: product,
                program: program,
                institution: institution,
                type: type  
            }
        })
    }

    validateDate(dateStr) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return false;
        }

        // 2. парсинг
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) {
            return false;
        }

        // 3. защита от "переполнения" дат (2023-02-31 → Mar 3)
        const [y, m, d] = dateStr.split("-").map(Number);
        if (
            date.getUTCFullYear() !== y ||
            date.getUTCMonth() + 1 !== m ||
            date.getUTCDate() !== d
        ) {
            return false;
        }

        // 4. проверка года
        return y > 2000;       
    }
    
    handleChangeStart(event) {
        this.setState(prevState => ({
            currentEvent: {
                ...prevState.currentEvent,
                start: event.target.value,
                end: event.target.value,
            },
            isDraft: true

        }))
    }

    handleChangeEnd(event) {
        this.setState(prevState => ({
            currentEvent: {
                ...prevState.currentEvent,
                end: event.target.value
            },
            isDraft: true

        }))
    }

    handleChangeOccupation(event) {
        var currentEvent = this.state.currentEvent
        currentEvent.occupation = event.target.value
        this.setState({currentEvent: currentEvent, isDraft: true})
    }

    handleChangeInstitution(selectedOption) {
        this.setState(prevState => ({
            currentEvent: {
                ...prevState.currentEvent,
                institutionid: selectedOption.value,
                institution: selectedOption.label
            }, 
            isDraft: true
        }))
    }

    handleChangeProduct(selectedOption) {
    console.log(selectedOption.value);
    this.setState(prevState => ({
        currentEvent: {
        ...prevState.currentEvent,
        productid: selectedOption.value,
        product: selectedOption.label
        },
        isDraft: true
    }));
    }

    handleChangeProgram(selectedOption) {
        this.setState(prevSate => ({
            currentEvent: {
                ...prevSate.currentEvent,
                programid: selectedOption.value,
                program: selectedOption.label,
                productid: null,
                product: ""
            },
            isDraft: true
        }))
    }

    handleChangeType(selectedOption) {
        this.setState(prevState => ({
            currentEvent: {
                ...prevState.currentEvent,
                typeid: selectedOption.value,
                type: selectedOption.label,
            },
            isDraft: true
        }));
    }

    handleChangeStatus(selectedOption) {
        this.setState(prevState => ( {
            currentEvent: {
                ...prevState.currentEvent,
                status: selectedOption.value,
                statusLabel: selectedOption.label
            },
            isDraft: true
        }))
    }

    handleChangeRegion(selectedOption) {
      this.setState(prevState => ({
            currentEvent: {  // ✅ вложи в объект currentEvent
                ...prevState.currentEvent,
                regionid: selectedOption.value,
                region: selectedOption.label,
            }
        }));
    }

    handleChangeProject(selectedOption) {
        this.setState(prevState => ( {
            currentEvent: {
                ...prevState.currentEvent,
                projectid: selectedOption.value,
                project: selectedOption.label
            },
            isDraft: true
        }))
    }

    openParticipants() {
        this.props.navigate("event-participant", 
        {caller: "event", callargs: this.props.args, eventid: this.state.currentEvent.id, event: this.state.currentEvent})
    }

    openVolunteers() {
        this.props.navigate("event-volunteers", 
        {caller: "event", callargs: this.props.args, eventid: this.state.currentEvent.id, event: this.state.currentEvent})    
    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "event", callargs: this.props.args, refrecid: this.state.currentEvent.id})    
    }

    openGallery() {
        this.props.navigate("event-gallery", {
            caller: "event",
            callargs: this.props.args,
            eventid: this.state.currentEvent.id,
            event: this.state.currentEvent
        });
    }

    openDocs() {
        this.props.navigate("event-docs", {
            caller: "event",
            callargs: this.props.args,
            eventid: this.state.currentEvent.id,
            event: this.state.currentEvent
        });
    }

    render() {
        const eventExists = !!this.state.currentEvent.id;

        return (
            <div className="container">
            <ScreenCaption
                goback={this.props.goback}
                args={this.props.args}
                caption={"Событие"}
            />

            <div className="row mt-4">
                {/* Форма события */}
                <div className="col-lg-8">
                <div className="card shadow-sm">
                    <div className="card-body">
                    <h6 className="card-title mb-3">
                        {eventExists ? "Редактирование события" : "Новое событие"}
                    </h6>
                    {this.state.isDraft &&
                       <span className="badge text-bg-warning">
                            Имеются несохранённые данные
                        </span>
                    }

                    <form onSubmit={this.save}>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <label 
                                htmlFor="start" 
                                className={`form-label ${this.state.validation.start ? "" : "text-danger"}`}
                            >
                                    Начало
                            </label>
                            <input
                                type="date"
                                className={`form-control ${this.state.validation.start ? "" : "text-danger"}`}
                                id="start"
                                value={this.state.currentEvent.start || ""}
                                onChange={this.handleChangeStart}
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label 
                                htmlFor="end" 
                                className={`form-label ${this.state.validation.end ? "" : "text-danger"}`}
                            >
                                Завершение
                            </label>
                            <input
                                type="date"
                                className={`form-control ${this.state.validation.end ? "" : "text-danger"}`}
                                id="end"
                                value={this.state.currentEvent.end || ""}
                                onChange={this.handleChangeEnd}
                            />
                        </div>
                        </div>
                        <div className = "row">
                            <div className="col-md-6 mb-3">
                                <label 
                                    htmlFor="occupation" 
                                    className="form-label">
                                        Занятость волонтёра (часы)
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    id="occupation"
                                    value={this.state.currentEvent.occupation || 0}
                                    onChange={this.handleChangeOccupation}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label 
                                    htmlFor="status" 
                                    className="form-label">
                                        Статус
                                    </label>  
                                <Select
                                    options={this.state.statusOptions}
                                    id="status"
                                    value={this.state.statusOptions.find(o => o.value === this.state.currentEvent.status)}
                                    onChange={this.handleChangeStatus}
                                    placeholder="Выберите статус"
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="region" 
                            className="form-label"
                        >
                            Регион
                        </label>
                        <Select
                            options={this.state.regionOptions}
                            id="institution"
                            value={this.state.regionOptions.find(o => o.value === this.state.currentEvent.regionid)}
                            onChange={this.handleChangeRegion}
                            placeholder="Выберите регион"
                        />
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="institution" 
                            className={`form-label ${this.state.validation.institution ? "" : "text-danger"}`}
                            >
                                Учреждение
                        </label>
                        <div
                            className={
                                this.state.validation.institution
                                ? "" : "border border-danger rounded"
                            }
                        >
                            <Select
                                options={this.state.instituteOptions}
                                id="institution"
                                onChange={this.handleChangeInstitution}
                                placeholder={this.state.currentEvent.institution || "Выберите учреждение"}
                            />
                        </div>
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="project" 
                            className={`form-label ${this.state.validation.project ? "" : "text-danger"}`}
                        >
                                Проект        
                        </label>
                        <div
                            className={
                                this.state.validation.project
                                ? "" : "border border-danger rounded"
                            }
                        >
                            <Select
                                options={this.state.projectOptions}
                                id="proоусе"
                                onChange={this.handleChangeProject}
                                placeholder={this.state.currentEvent.project || "Выберите проект"}
                            />
                        </div>
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="program" 
                            className={`form-label ${this.state.validation.program ? "" : "text-danger"}`}
                        >
                            Программа
                        </label>
                        <div
                            className={
                                this.state.validation.program
                                ? "" : "border border-danger rounded"
                            }
                        >
                            <Select
                                options={this.state.programOptions}
                                id="program"
                                onChange={this.handleChangeProgram}
                                placeholder={this.state.currentEvent.program || "Выберите программу"}
                            />
                        </div>
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="product" 
                            className={`form-label ${this.state.validation.product ? "" : "text-danger"}`}
                        >
                            Продукт
                        </label>
                        <div
                            className={
                                this.state.validation.product
                                ? "" : "border border-danger rounded"
                            }
                        >
                            <Select
                                options={this.state.productOptions}
                                id="product"
                                onChange={this.handleChangeProduct}
                                placeholder={this.state.currentEvent.product || "Выберите продукт"}
                            />
                        </div>
                        </div>

                        <div className="mb-3">
                        <label 
                            htmlFor="type" 
                            className={`form-label ${this.state.validation.type ? "" : "text-danger"}`}
                        >  
                            Тип
                        </label>
                        <div
                            className={
                                this.state.validation.type
                                ? "" : "border border-danger rounded"
                            }
                        >
                            <Select
                                options={this.state.typeOptions}
                                id="type"
                                onChange={this.handleChangeType}
                                placeholder={this.state.currentEvent.type || "Выберите тип"}
                            />
                        </div>
                        </div>

                        <div className="mt-4 d-flex justify-content-end">
                        <button 
                            type="submit" 
                            className="btn btn-primary" 
                            onClick={this.save}
                            disabled = {!this.state.isDraft || !this.state.validation.isValid}
                        >
                            Сохранить
                        </button>
                        {this.state.saved && (
                            <span className="badge text-bg-success">
                            Данные сохранены
                            </span>
                        )}
                        </div>
                    </form>
                    </div>
                </div>
                </div>

                {/* Правая колонка действий */}
                <div className="col-lg-4 mt-4 mt-lg-0">
                <div className="card shadow-sm">
                    <div className="card-body">
                    <h6 className="card-title mb-3">Действия</h6>

                    {eventExists && (
                        <div>
                        <button
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={() => { this.openParticipants(); }}
                        >
                            Участники
                        </button>

                        <button
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={() => { this.openVolunteers(); }}
                        >
                            Волонтёры
                        </button>
                        <button
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={() => { this.openRefs(); }}
                        >
                            Ссылки
                        </button>

                        <button
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={() => { this.openGallery(); }}
                        >
                            Фотоотчёт
                        </button>
                        <button
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={() => { this.openDocs(); }}
                        >
                            Документы
                        </button>
                        {["admin", "manager"].includes(this.state.role) &&
                            <button
                                className="btn btn-outline-primary w-100 mb-2"
                                onClick={() => { this.delete(); }}
                            >
                                Удалить
                            </button>
                        }
                        </div>
                    )}

                    {!eventExists && (
                        <p className="text-muted mb-0">
                        Дополнительные действия станут доступны после сохранения события.
                        </p>
                    )}
                    </div>
                </div>
                </div>
            </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event.js